export default "<section  class=\"construccion\">\n    <div class=\"container\">\n        <h2>Sección en construcción</h2>        \n    </div>\n</section>\n"